@if (filterPills().length > 0) {
	<div class="py-6 space-y-2 border-b border-gray-200">
		<span
			class="block pb-2 text-base font-medium text-gray-500 pointer-events-none"
			role="presentation"
		>
			Applied filters:
		</span>
		<div class="flex flex-wrap gap-2">
			@for (pill of filterPills(); track $index) {
				<uc-course-search-filter-pill
					[pill]="pill"
					(removePill)="onRemovePill($event)"
				/>
			}
		</div>
		<ng-content></ng-content>
		<div class="pt-2 lg:hidden">
			<button
				type="button"
				class="inline mb-2 text-xs text-gray-500 border-b border-gray-500 only-tab-focus hover:text-gray-700"
				(click)="onResetFilters()"
			>
				Clear all filters
			</button>
		</div>
	</div>
}
